// import React, { useEffect, useRef } from 'react';
// import { WifiOff, Loader2,LoaderPinwheel, Loader2Icon, CameraIcon, Camera, CameraOffIcon, Mic, MicOff } from 'lucide-react';
// import { MdMic, MdMicOff } from 'react-icons/md';

//  import './RemoteVideo.scss';

// const RemoteVideo = ({ 
//   stream, 
//   userId, 
//   isVideoOn, 
//   isAudioOn,
//   userName, 
//   className = '',
//   isPip = false ,
//   userData,
//   isDisconnected = false,
//   onRemoveDisconnected
// }) => {
//   const containerRef = useRef(null);
//   const disconnectTimerRef = useRef(null);
//   const [timeRemaining, setTimeRemaining] = React.useState(120);
//   useEffect(() => {
//     if (isDisconnected) {
//       console.log(`⏰ Starting 30-second timer for disconnected user ${userId}`);
      
//       // Start countdown
//       disconnectTimerRef.current = setInterval(() => {
//         setTimeRemaining(prev => {
//           if (prev <= 1) {
//             // Time's up - remove the user
//             clearInterval(disconnectTimerRef.current);
//             if (onRemoveDisconnected) {
//               onRemoveDisconnected(userId);
//             }
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     } else {
//       // User reconnected - clear timer
//       if (disconnectTimerRef.current) {
//         clearInterval(disconnectTimerRef.current);
//         disconnectTimerRef.current = null;
//       }
//       setTimeRemaining(120); // Reset timer
//     }

//     // Cleanup on unmount
//     return () => {
//       if (disconnectTimerRef.current) {
//         clearInterval(disconnectTimerRef.current);
//       }
//     };
//   }, [isDisconnected, userId, onRemoveDisconnected]);

//   useEffect(() => {
//     console.log(userData,isDisconnected,"userData in remote video");
//     if (!stream || !userId || !containerRef.current || isDisconnected) return;

//     let mounted = true;

//     const attachVideo = async () => {
//       if (!mounted) return;

//       try {
//         if (isVideoOn) {
//           console.log(`🎥 Attaching video for user ${userId}`);
          
//           // Clear container first
//           if (containerRef.current) {
//             containerRef.current.innerHTML = '';
//           }

//           // Create a proper container structure for Zoom SDK
//           const videoContainer = document.createElement('div');
//           videoContainer.className = 'video-player-container';
//           videoContainer.style.width = '100%';
//           videoContainer.style.height = '100%';
//           videoContainer.style.position = 'relative';

//           // Attach video to the container
//           const videoElement = await stream.attachVideo(userId, 3);
//           videoElement.style.width = '100%';
//           videoElement.style.height = '100%';
//           videoElement.style.objectFit = 'cover';
//           videoElement.className = 'zoom-video-element';

//           videoContainer.appendChild(videoElement);
          
//           if (containerRef.current && mounted) {
//             containerRef.current.appendChild(videoContainer);
//           }
          
//           console.log(`✅ Video attached for user ${userId}`);
//         } else {
//           // Video is off - detach and show placeholder
//           console.log(`🔌 Detaching video for user ${userId}`);
//           try {
//             await stream.detachVideo(userId);
//           } catch (detachError) {
//             console.log('Video already detached or error:', detachError);
//           }
          
//           // Clear container
//           if (containerRef.current && mounted) {
//             containerRef.current.innerHTML = '';
//           }
//         }
//       } catch (error) {
//         console.error(`❌ Error handling video for user ${userId}:`, error);
//       }
//     };
   
   
//     attachVideo();

//     return () => {
//       mounted = false;
//       // Cleanup when component unmounts or dependencies change
//       if (stream && userId) {
//         try {
//           stream.detachVideo(userId);
//         } catch (cleanupError) {
//           console.log('Cleanup detach error:', cleanupError);
//         }
//       }
//     };
//   }, [stream, userId, isVideoOn,isAudioOn,isDisconnected]);

//   useEffect(() => {
//     if (isDisconnected && containerRef.current) {
//       // Remove the video element from container
//       containerRef.current.innerHTML = '';
//       if (stream && userId) {
//         try {
//           stream.detachVideo(userId);
//         } catch (e) {
//           // Already detached or error, log if necessary
//           console.log('Detach error on disconnect:', e);
//         }
//       }
//     }
//   }, [isDisconnected, stream, userId]);
  

//   // if (isDisconnected) {

//   //   return (
//   //     <div className={`remote-video disconnected ${className} ${isPip ? 'pip-mode' : ''}`}>
//   //       <div className="disconnected-overlay">
//   //         <div className="disconnected-content">
//   //           <div className="spinner-container">
//   //             <Loader2Icon className="reconnection-spinner" />
//   //           </div>
//   //           {/* <WifiOff className="disconnected-icon" /> */}
//   //           <p className="disconnected-text">Connection Lost</p>
//   //           <p className="reconnecting-text">
//   //             Reconnecting... {timeRemaining}s
//   //           </p>
          
//   //   </div> 
//   //       </div>
        
//   //       {/* Keep the container structure for consistency */}
//   //       <div
//   //         ref={containerRef}
//   //         className="video-container disconnected-bg"
//   //         style={{
//   //           width: '100%',
//   //           height: '100%',
//   //           position: 'relative',
//   //           backgroundColor: '#2d2d2d'
//   //         }}
//   //       >
//   //       </div>

//   //       {/* Bottom overlay for disconnected state */}
//   //       <div className="bottom-overlay disconnected-overlay-info">
//   //         <div className="overlay-content">
//   //           <div className="user-details">
//   //             <div className="video-status">
//   //               <div className="status-dot disconnected"></div>
//   //             </div>
//   //             <span className="user-name">
//   //               {userName || 'User'} (Disconnected)
//   //             </span>
//   //             <span className="disconnect-timer">{timeRemaining}s</span>
//   //           </div>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // }
//   if (isDisconnected) {
//     return (
//       <div className={`remote-video disconnected ${className} ${isPip ? 'pip-mode' : ''}`}>
//         {/* Video container - will be grayed out in background */}
//         <div
//           ref={containerRef}
//           className="video-container disconnected-bg"
//           style={{
//             width: '100%',
//             height: '100%',
//             position: 'relative',
//             backgroundColor: '#2d2d2d'
//           }}
//         />
  
//         {/* Disconnected overlay - on top of video */}
//         <div className="disconnected-overlay">
//           <div className="disconnected-content">
//             <div className="spinner-container">
//               <Loader2Icon className="reconnection-spinner" />
//             </div>
//             <p className="disconnected-text">Connection Lost</p>
//             <p className="reconnecting-text">
//               Reconnecting... {timeRemaining}s
//             </p>
//           </div> 
//         </div>
  
//         {/* Bottom overlay for disconnected state */}
//         <div className="bottom-overlay disconnected-overlay-info">
//           <div className="overlay-content">
//             <div className="user-details">
//               <div className="video-status">
//                 <div className="status-dot disconnected"></div>
//               </div>
//               <span className="user-name">
//                 {userName || 'User'} (Disconnected)
//               </span>
//               <span className="disconnect-timer">{timeRemaining}s</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }


//   return (
//     <div className={`remote-video ${className} ${isPip ? 'pip-mode' : ''}`}>
//       {/* Video container */}
//       <div
//         ref={containerRef}
//         className="video-container"
//         style={{
//           width: '100%',
//           height: '100%',
//           position: 'relative',
//           backgroundColor: '#1a1a1a'
//         }}
//       >
//         {/* Video will be inserted here by Zoom SDK */}

//       </div>

//       {/* Professional placeholder when video is off */}
//       {!isVideoOn && (
//         <div className="video-off-placeholder">
//           <div className="user-avatar">
//             <div className="avatar-circle">
//               {(userName || 'User').charAt(0).toUpperCase()}
//             </div>
            
//           </div>
       
//         </div>
//       )}

//       {/* Bottom overlay with user info */}
//       <div className="bottom-overlay">
//         <div className="overlay-content">
//           <div className="user-details">
           
//             <span className="user-name">
//               {userName || 'User'}
//             </span>
//             <div className="video-status">
//               {isVideoOn ? (
//                 <>
//                   {/* <div className="status-dot live"></div> */}
//                   <CameraIcon className='camera'/>
//                 </>
//               ) : (
//                 <>
//                   <CameraOffIcon className='camera'/>
//                 </>
//               )}
//               { isAudioOn? (
//                 <>
//                   <MdMic className='camera'/>
//                 </>
//               ) : (
//                 <>
//                   <MdMicOff className='camera'/>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RemoteVideo;

import React, { useEffect, useRef } from 'react';
import { Loader2Icon, CameraIcon, CameraOffIcon } from 'lucide-react';
import { MdMic, MdMicOff } from 'react-icons/md';

import './RemoteVideo.scss';

const RemoteVideo = ({
  stream,
  userId,
  isVideoOn,
  isAudioOn,
  userName,
  className = '',
  isPip = false,
  userData,
  isDisconnected = false,
  onRemoveDisconnected,
}) => {
  const containerRef = useRef(null);
  const disconnectTimerRef = useRef(null);
  const [timeRemaining, setTimeRemaining] = React.useState(120);

  useEffect(() => {
    if (isDisconnected) {
      disconnectTimerRef.current = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            clearInterval(disconnectTimerRef.current);
            disconnectTimerRef.current = null;
            if (onRemoveDisconnected) {
              onRemoveDisconnected(userId);
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      if (disconnectTimerRef.current) {
        clearInterval(disconnectTimerRef.current);
        disconnectTimerRef.current = null;
      }
      setTimeRemaining(120);
    }
    return () => {
      if (disconnectTimerRef.current) {
        clearInterval(disconnectTimerRef.current);
        disconnectTimerRef.current = null;
      }
    };
  }, [isDisconnected, userId, onRemoveDisconnected]);

  useEffect(() => {
    if (!stream || !userId || !containerRef.current || isDisconnected) return;

    let mounted = true;

    const attachVideo = async () => {
      if (!mounted) return;
      try {
        const videoPlayerContainer = containerRef.current.querySelector('video-player-container');
        if (!videoPlayerContainer) {
          console.warn('Static <video-player-container> missing in DOM');
          return;
        }

        if (isVideoOn) {
          videoPlayerContainer.innerHTML = '';

          // Small delay to mitigate rendering issues in Edge
          await new Promise(resolve => setTimeout(resolve, 0));

          const videoElement = await stream.attachVideo(userId, 3);
          videoElement.style.width = '100%';
          videoElement.style.height = '100%';

          // ss update
          videoElement.style.position = 'absolute';
          videoElement.style.top = '0';
          videoElement.style.left = '0';
          
          videoElement.style.objectFit = 'cover';
          videoElement.className = 'zoom-video-element';

          videoPlayerContainer.appendChild(videoElement);
        } else {
          videoPlayerContainer.innerHTML = '';
          try {
            await stream.detachVideo(userId);
          } catch {}
        }
      } catch (error) {
        console.error(`Error handling video for user ${userId}:`, error);
      }
    };

    attachVideo();

    return () => {
      mounted = false;
      if (stream && userId) {
        try {
          stream.detachVideo(userId);
        } catch(e) {
          console.log('Cleanup detach error:', e);
        }
      }
    };
  }, [stream, userId, isVideoOn, isAudioOn, isDisconnected]);

  useEffect(() => {
    if (isDisconnected && containerRef.current) {
      const videoPlayerContainer = containerRef.current.querySelector('video-player-container');
      if (videoPlayerContainer) videoPlayerContainer.innerHTML = '';
      if (stream && userId) {
        try {
          stream.detachVideo(userId);
        } catch (e) {
          console.log('Detach error on disconnect:', e);
        }
      }
    }
  }, [isDisconnected, stream, userId]);

  // if (isDisconnected) {
  //   return (
  //     <div className={`remote-video disconnected ${className} ${isPip ? 'pip-mode' : ''}`}>
  //       <div
  //         ref={containerRef}
  //         className="video-container disconnected-bg"
  //         style={{
  //           width: '100%',
  //           height: '100%',
  //           position: 'relative',
  //           backgroundColor: '#2d2d2d',
  //         }}
  //       >
  //         <video-player-container style={{ width: '100%', height: '100%', position: 'relative' }}></video-player-container>
  //       </div>
  //       <div className="disconnected-overlay">
  //         <div className="disconnected-content">
  //           <div className="spinner-container">
  //             <Loader2Icon className="reconnection-spinner" />
  //           </div>
  //           <p className="disconnected-text">Connection Lost</p>
  //           <p className="reconnecting-text">Reconnecting... {timeRemaining}s</p>
  //         </div>
  //       </div>
  //       <div className="bottom-overlay disconnected-overlay-info">
  //         <div className="overlay-content">
  //           <div className="user-details">
  //             <div className="video-status">
  //               <div className="status-dot disconnected"></div>
  //             </div>
  //             <span className="user-name">{userName || 'User'} (Disconnected)</span>
  //             <span className="disconnect-timer">{timeRemaining}s</span>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  if (isDisconnected) {
    return (
      <div className={`remote-video disconnected ${className} ${isPip ? 'pip-mode' : ''}`}>
        <div
          ref={containerRef}
          className="video-container disconnected-bg"
          style={{
            width: '100%',
            height: '100%',
            position: 'relative',
            backgroundColor: '#2d2d2d',
          }}
        >
          <video-player-container style={{ width: '100%', height: '100%', position: 'relative' }}></video-player-container>
        </div>
        
        <div className="disconnected-overlay">
          <div className="disconnected-content">
            <div className="spinner-container">
              <Loader2Icon className="reconnection-spinner" />
            </div>
            <p className="disconnected-text">Connection Lost</p>
            <p className="reconnecting-text">Reconnecting... {timeRemaining}s</p>
          </div>
        </div>
        
        <div className="bottom-overlay disconnected-overlay-info">
          <div className="overlay-content">
            <div className="user-details">
              <div className="video-status">
                <div className="status-dot disconnected"></div>
              </div>
              <span className="user-name">{userName || 'User'}</span>
              <span className="disconnect-timer">{timeRemaining}s</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`remote-video ${className} ${isPip ? 'pip-mode ' : ''}`}>
      <div
        ref={containerRef}
        className="video-container"
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          backgroundColor: '#1a1a1a',
        }}
      >
        {/* Static Zoom SDK container element */}
        <video-player-container style={{ width: '100%', height: '100%', position: 'relative' }}></video-player-container>
      </div>

      {!isVideoOn && (
        <div className="video-off-placeholder">
          <div className="user-avatar">
            <div className="avatar-circle">{(userName || 'User').charAt(0).toUpperCase()}</div>
          </div>
        </div>
      )}

      <div className="bottom-overlay">
        <div className="overlay-content">
          <div className="user-details">
            <span className="user-name">{userName || 'User'}</span>
            <div className="video-status">
              {isVideoOn ? <CameraIcon className="camera" /> : <CameraOffIcon className="camera" />}
              {isAudioOn ? <MdMic className="camera" /> : <MdMicOff className="camera" />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoteVideo;
